export default __webpack_public_path__ + "static/media/radioActive.397b90dc.svg";